
// src/actions/menus.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'
import { getArray } from '../helpers/store'

export const INIT_MENU = "INIT_MENU"
export const SORT_MENU = "SORT_MENU"
export const SET_FREE_MENU = "SET_FREE_MENU"
export const SET_NOT_FREE_MENU = "SET_NOT_FREE_MENU"
export const SET_FLASH_NEW_FREE_GROUP_ID = "SET_FLASH_NEW_FREE_GROUP_ID"
export const EXPAND_DIVISION = "EXPAND_DIVISION"
export const EXPAND_DIVISION_SORT = "EXPAND_DIVISION_SORT"
export const COLLAPSE_DIVISION = "COLLAPSE_DIVISION"
export const COLLAPSE_DIVISION_SORT = "COLLAPSE_DIVISION_SORT"

export const EXPAND_DIVISION_NOT_SET_GROUP = "EXPAND_DIVISION_NOT_SET_GROUP"
export const EXPAND_DIVISION_SORT_NOT_SET_GROUP = "EXPAND_DIVISION_SORT_NOT_SET_GROUP"
export const SET_SORTING_MENU_POSITION = "SET_SORTING_MENU_POSITION"

const MaxItemPerMenu = 100
const MaxDivisionPerMenu = 500

export function initMenus(userMenus, divisions, allgroups) {
  const menuItems = userMenus && userMenus.length > 0 ? defaultUserMenuItems(userMenus, divisions, allgroups) : defaultMenuItems(divisions, allgroups)

  return {
    type: INIT_MENU,
    results: menuItems,
  }
}

function defaultUserMenuItems(userMenus, divisions, groups) {
  if (!divisions || !groups) return []
  let divisionMenu = getBlankDivisionMenu(divisions)
  const oldDivisionMenu = userMenus.filter(item => item.type == 'division')
  let freeGroupsMenu = getBlankFreeGroupMenu(groups)
  const oldFreeGroupsMenu = userMenus.filter(item => item.type == 'group' && item.is_free)
  freeGroupsMenu = applyOldFreeGroupsToNewFreeGroup(oldFreeGroupsMenu, freeGroupsMenu)
  const oldFreeMenu = userMenus.filter(item => item.is_free)
  let newFreeMenu = [].concat(divisionMenu, freeGroupsMenu)

  let nonFreeGroupsMenu = getBlankNonFreeGroupMenu(divisions, groups)
  const oldNonFreeGroupsMenu = userMenus.filter(item => item.type == 'group' && !item.is_free)
  nonFreeGroupsMenu = applyOldFreeGroupsToNewNonFreeGroup(oldFreeGroupsMenu, nonFreeGroupsMenu)

  sortNewMenuWithOldPosition(oldFreeMenu, newFreeMenu)
  sortNewMenuWithOldPosition(oldNonFreeGroupsMenu, nonFreeGroupsMenu)

  let menuItems = [].concat(newFreeMenu, nonFreeGroupsMenu)
  return applyMenuPosition(menuItems)
}

function defaultMenuItems(divisions, groups) {
  if (!divisions || !groups) return []
  const divisionMenu = getBlankDivisionMenu(divisions)
  const freeGroupsMenu = getBlankFreeGroupMenu(groups)
  const nonFreeGroupsMenu = getBlankNonFreeGroupMenu(divisions, groups)
  let menuItems = [].concat(divisionMenu, freeGroupsMenu, nonFreeGroupsMenu)

  return applyMenuPosition(menuItems)
}

function applyOldFreeGroupsToNewFreeGroup(oldFreeGroupsMenu, menuItems) {
  oldFreeGroupsMenu.forEach(oldMenu => {
    if (oldMenu.is_free_group) return
    if (menuItems.find(item => item.type == 'group' && item.item_id == oldMenu.item_id && item.is_free)) return
    menuItems.push({
      item_id: oldMenu.item_id,
      type: 'group',
      is_free: true,
      is_free_group: false
    })
  })
  return menuItems
}
function applyOldFreeGroupsToNewNonFreeGroup(oldFreeGroupsMenu, menuItems) {
  oldFreeGroupsMenu.forEach(oldMenu => {
    if (oldMenu.is_free_group) return
    menuItems = menuItems.filter(item => (item.type != 'group' || item.item_id != oldMenu.item_id || item.is_free))
  })
  return menuItems
}

function sortNewMenuWithOldPosition(oldMenuItems, newMenuItems) {
  newMenuItems.sort((item1, item2) => {
    const oldItem1 = oldMenuItems.find(item => item.item_id == item1.item_id && item.parent_id == item1.parent_id)
    const oldItem2 = oldMenuItems.find(item => item.item_id == item2.item_id && item.parent_id == item2.parent_id)
    if (!oldItem1 && !oldItem2)
      return 0
    if (!oldItem2)
      return -1
    if (!oldItem1)
      return 1
    return oldItem1.position - oldItem2.position
  })
}

function getBlankDivisionMenu(divisions) {
  let menuItems = []
  divisions.forEach((division) => {
    menuItems.push({
      item_id: division.division_id,
      type: 'division',
      is_free: true,
    })
  })
  return menuItems
}

function getBlankFreeGroupMenu(groups) {
  let menuItems = []
  const freeGroups = groups.filter(group => group.is_free_group)
  freeGroups.forEach((group) => {
    menuItems.push({
      item_id: group.group_id,
      type: 'group',
      is_free: true,
      is_free_group: group.is_free_group,
    })
  })
  return menuItems
}

function getBlankNonFreeGroupMenu(divisions, groups) {
  let menuItems = []
  const nonFreeGroups = groups.filter(group => !group.is_free_group)
  divisions.forEach((division) => {
    const divisionGroups = nonFreeGroups.filter(group => division.groups.map(g => g.id).includes(group.group_id))
    divisionGroups.forEach(group => {
      menuItems.push({
        item_id: group.group_id,
        type: 'group',
        is_free: false,
        is_free_group: group.is_free_group,
        parent_id: division.division_id
      })
    })
  })
  return menuItems
}

export function applyMenuPosition(menuItems) {
  menuItems.filter(menuItem => menuItem.type == 'division' && menuItem.is_free).forEach((menuItem, index) => {
    menuItem.position = (index + 1)*MaxItemPerMenu
  })
  menuItems.filter(menuItem => menuItem.type == 'group' && menuItem.is_free).forEach((menuItem, index) => {
    menuItem.position = MaxDivisionPerMenu*MaxItemPerMenu + index + 1
  })
  menuItems.filter(menuItem => menuItem.type == 'division').forEach(divisionMenu => {
    const groupMenus = menuItems.filter(menuItem => menuItem.parent_id == divisionMenu.item_id)
    groupMenus.forEach((groupMenu, index) => {
      groupMenu.position = divisionMenu.position + index + 1
    })
  })
  return menuItems.sort((item1, item2) => item1.position - item2.position)
}

export function setNewMenuPositions(newPositions) {
  let changeIndex
  newPositions.forEach((item, index) => {
    if (index == 0) return
    if (newPositions[index -1 ] > item) {
      changeIndex = index-1
    }
  })
  let oldPosition, newPosition
  if (newPositions[changeIndex-1] != (newPositions[changeIndex] - 1)
    && newPositions[changeIndex+1] != (newPositions[changeIndex] + 1)
    && newPositions[changeIndex-1] != (newPositions[changeIndex] - MaxItemPerMenu)
    && newPositions[changeIndex+1] != (newPositions[changeIndex] + MaxItemPerMenu)) {
      oldPosition = newPositions[changeIndex]
      newPosition = newPositions[changeIndex + 1]
  } else {
    oldPosition = newPositions[changeIndex + 1]
    newPosition = newPositions[changeIndex]
  }
  return {
    type: SORT_MENU,
    results: {
      oldPosition, newPosition
    },
  }
}

export function sortMenu(oldPosition, newPosition) {
  return {
    type: SORT_MENU,
    results: {
      oldPosition, newPosition
    },
  }
}

export function setFreeMenu(position) {
  return {
    type: SET_FREE_MENU,
    results: {
      position
    },
  }
}

export function setNotFreeMenu(position, groupDivisionIds) {
  return {
    type: SET_NOT_FREE_MENU,
    results: {
      position,
      groupDivisionIds
    },
  }
}

export function setFlashNewFreeGroupId(item_id) {
  return {
    type: SET_FLASH_NEW_FREE_GROUP_ID,
    results: item_id,
  }
}

export function expandDivision(item_id) {
  return {
    type: EXPAND_DIVISION,
    results: item_id,
  }
}

export function expandDivisionSort(item_id) {
  return {
    type: EXPAND_DIVISION_SORT,
    results: item_id,
  }
}

export function collapseDivision(item_id) {
  return {
    type: COLLAPSE_DIVISION,
    results: item_id,
  }
}

export function collapseDivisionSort(item_id) {
  return {
    type: COLLAPSE_DIVISION_SORT,
    results: item_id,
  }
}

export function expandDivisionNotSetGroup() {
  return {
    type: EXPAND_DIVISION_NOT_SET_GROUP,
  }
}

export function expandDivisionSortNotSetGroup() {
  return {
    type: EXPAND_DIVISION_SORT_NOT_SET_GROUP,
  }
}

export function setSortingMenuPosition(position) {
  return {
    type: SET_SORTING_MENU_POSITION,
    results: position,
  }
}



// WEBPACK FOOTER //
// ./src/actions/menus.js